// ✅ Phase 3.1 — Daxili söhbət (admin/staff) reducer
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_internal_conversations = createAsyncThunk(
    'internalChat/get_conversations',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/internal-chat/conversations', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Söhbətlər yüklənmədi' })
        }
    }
)

export const get_internal_users = createAsyncThunk(
    'internalChat/get_users',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/internal-chat/users', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'İstifadəçilər yüklənmədi' })
        }
    }
)

export const get_internal_messages = createAsyncThunk(
    'internalChat/get_messages',
    async (conversationId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/internal-chat/conversations/${conversationId}/messages`, { withCredentials: true })
            return fulfillWithValue({ conversationId, messages: data.messages || [] })
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Mesajlar yüklənmədi' })
        }
    }
)

export const create_internal_conversation = createAsyncThunk(
    'internalChat/create_conversation',
    async ({ participantId }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/admin/internal-chat/conversations', { participantId }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Söhbət yaradıla bilmədi' })
        }
    }
)

export const send_internal_message = createAsyncThunk(
    'internalChat/send_message',
    async ({ conversationId, message }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/admin/internal-chat/conversations/${conversationId}/messages`, { message }, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Mesaj göndərilmədi' })
        }
    }
)

export const internalChatReducer = createSlice({
    name: 'internalChat',
    initialState: {
        conversations: [],
        users: [],
        messages: [],
        activeConversationId: null,
        loader: false,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        setActiveConversation: (state, { payload }) => {
            state.activeConversationId = payload
        },
        // Socket-dən gələn mesaj (real-time)
        receiveInternalMessage: (state, { payload }) => {
            const msg = payload?.message
            if (!msg) return
            if (msg.conversationId === state.activeConversationId) {
                const exists = state.messages.some(m => m._id === msg._id)
                if (!exists) state.messages.push(msg)
            }
            // söhbət siyahısında son mesajı yenilə + yuxarı qaldır
            state.conversations = state.conversations.map(c =>
                c._id === msg.conversationId
                    ? { ...c, lastMessageAt: msg.createdAt, lastMessageText: (msg.message || '').slice(0, 140) }
                    : c
            )
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_internal_conversations.fulfilled, (state, { payload }) => {
                state.conversations = payload.conversations || []
            })
            .addCase(get_internal_users.fulfilled, (state, { payload }) => {
                state.users = payload.users || []
            })
            .addCase(get_internal_messages.pending, (state) => { state.loader = true })
            .addCase(get_internal_messages.fulfilled, (state, { payload }) => {
                state.loader = false
                state.activeConversationId = payload.conversationId
                state.messages = payload.messages
            })
            .addCase(get_internal_messages.rejected, (state, { payload }) => {
                state.loader = false
                state.errorMessage = payload?.error || 'Xəta'
            })
            .addCase(create_internal_conversation.fulfilled, (state, { payload }) => {
                const conv = payload.conversation
                if (conv && !state.conversations.some(c => c._id === conv._id)) {
                    state.conversations = [conv, ...state.conversations]
                }
                if (conv) state.activeConversationId = conv._id
            })
            .addCase(create_internal_conversation.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Xəta'
            })
            .addCase(send_internal_message.fulfilled, (state, { payload }) => {
                const msg = payload.data
                if (msg && msg.conversationId === state.activeConversationId) {
                    const exists = state.messages.some(m => m._id === msg._id)
                    if (!exists) state.messages.push(msg)
                }
            })
            .addCase(send_internal_message.rejected, (state, { payload }) => {
                state.errorMessage = payload?.error || 'Mesaj göndərilmədi'
            })
    }
})

export const { messageClear, setActiveConversation, receiveInternalMessage } = internalChatReducer.actions
export default internalChatReducer.reducer
